import { connect } from 'react-redux'
import elementSelector from './elementSelector'
import requestChangeElementName from '../sagas/requestChangeElementName'
import requestRemoveElement from '../sagas/requestRemoveElement'
import {
  add as addLocalSetting,
  remove as removeLocalSetting
} from 'store/redux/localSettings'
import Element from './Element'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  elementSelector,
  {
    requestChangeElementName,
    requestRemoveElement,
    addLocalSetting,
    removeLocalSetting
  },
  null,
  {
    forwardRef: true
  }
)(Element))
